/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresCreateEntry } from "../../funcs/llmMemoryStoresCreateEntry.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateMemoryEntryRequest$inboundSchema,
};

export const tool$llmMemoryStoresCreateEntry: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-create-entry",
  description: `Create memory entry`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresCreateEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
